<template>
	<div>
		<BaseThemeGdpr />
	</div>
</template>

<style scoped lang="less">
	:deep(.gdpr-icon){display: none!important;}
</style>